import { useWebSocketMeasurementContext } from '../providers/WebSocketMeasurementProvider';
import { IProcessedMeasurement, IProcessedMeasurementError } from 'app/types/measurement';

interface UseWebSocketMeasurementServiceReturn {
  measurements: IProcessedMeasurement[];
  measurementErrors: IProcessedMeasurementError[];
  status: string;
  connect: () => void;
  disconnect: () => void;
  isConnected: boolean;
}

export const useWebSocketMeasurementService = (): UseWebSocketMeasurementServiceReturn => {
  const context = useWebSocketMeasurementContext();

  return {
    measurements: context.measurements,
    measurementErrors: context.measurementErrors,
    status: context.status,
    connect: context.connect,
    disconnect: context.disconnect,
    isConnected: context.isConnected,
  };
};
